<template>
  <div class="recruitMsg">
    <div class="back-img"></div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/recruit' }"
        >人才招聘</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ jobData.post_name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <div class="job">
        <h2 class="mb-20">{{ jobData.post_name }}</h2>
        <div class="content-msg">
          <div class="item" style="margin-left:50px">
            <p>
              工作地点：
              <span>{{ jobData.address }}</span>
            </p>
            <p>
              招聘人数：
              <span>{{ jobData.num }}</span>
            </p>
          </div>
          <div class="item">
            <div>
              <p>
                所属子公司：
                <span>{{ jobData.company_name }}</span>
              </p>
            </div>
            <div>
              <p>
                职位类别：
                <span>{{ jobData.post_type }}</span>
              </p>
            </div>
          </div>
          <div class="item" style="margin-right:50px">
            <div class="time">
              <p>
                发布时间：
                <span>{{ jobData.issue_time }}</span>
              </p>
              <p>
                <el-button
                  @click="dialogFormVisible = true"
                  icon="el-icon-position"
                  plain
                  type="primary"
                  >我要应聘</el-button
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="job-msg" v-html="jobData.requirement"></div>
    </div>
    <el-dialog
      :before-close="handleClose"
      :visible.sync="dialogFormVisible"
      title="我要应聘"
      width="500px"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item :label-width="formLabelWidth" label="姓名:" prop="name">
          <el-input autocomplete="off" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          :label-width="formLabelWidth"
          label="联系方式:"
          prop="phone"
        >
          <el-input autocomplete="off" v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="留言" prop="content">
          <el-input type="textarea" v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item class="emailMsg"
          >简历投递邮箱：HR@pinnongjt.com</el-form-item
        >
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button @click="delivery('ruleForm')" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Qs from 'qs'
import { getRecruitDetails, addRecruitApply } from '@/api/recruit'
export default {
  data() {
    return {
      jobData: '',
      id: this.$route.params.id,
      dialogFormVisible: false,
      form: {
        name: '',
        phone: '',
        content: ''
      },
      rules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        content: [{ required: true, message: '必填', trigger: 'blur' }],
        phone: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      formLabelWidth: '100px'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const data = { id: this.id }
      getRecruitDetails(data)
        .then(res => {
          this.jobData = res.data
        })
        .catch(err => {
          console.log(err)
        })
      // this.$http.post('/getRecruitDetails', data).then(res => {
      //   this.jobData = res.data.data
      // })
    },
    //应聘申请
    delivery(formName) {
      let isPhone = /^1[3456789]\d{9}$/
      let phone = this.form.phone
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!isPhone.test(phone)) {
            return this.Message.warning('请正确输入手机号码')
          }
          addRecruitApply({ ...this.form, recruit_id: this.id })
            .then(res => {
              if (res.code) {
                this.dialogFormVisible = false
                this.Message.success('提交成功')
                this.form = {}
              } else {
                this.Message.warning('提交失败')
              }
            })
            .catch(err => {
              console.log(err)
            })
          // this.$http
          //   .post(
          //     '/addRecruitApply ',
          //     Qs.stringify({ ...this.form, recruit_id: this.id })
          //   )

          //   .then(res => {
          //     if (res.data.code) {
          //       this.dialogFormVisible = false
          //       this.Message.success('提交成功')
          //       this.form = {}
          //     } else {
          //       this.Message.warning('提交失败')
          //     }
          //   })
        } else {
          this.Message.warning('请输入信息')
          return false
        }
      })
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogFormVisible = false
    },
    // 关闭弹框
    handleClose() {
      this.dialogFormVisible = false
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scope>
.recruitMsg {
  .back-img {
    background-image: url('../../assets/image/recruit.png');
    margin-top: -62px;
  }
  .el-breadcrumb {
    width: 65%;
    margin: 30px auto 50px auto;
  }
  .content {
    color: #666666;
    .job {
      margin: auto;
      padding: 20px 0;
      border: 1px solid #cccccc;
      width: 65%;
      white-space: nowrap;

      h2 {
        font-size: 24px;
        text-align: initial;
        text-align: start;
        margin-left: 50px;
        font-size: 24px;
        color: #232323;
        font-weight: normal;
      }
      .content-msg {
        display: flex;
        justify-content: space-between;
        .item {
          display: flex;
          flex-direction: column;
          p {
            text-align: start;
            text-align: initial;
            padding-bottom: 15px;
          }
        }
      }
      .top,
      .bottom {
        display: flex;
        div {
          padding: 10px 50px;
        }
      }
      .top {
        // justify-content: space-between;
      }
      .time {
        margin-left: 55px;
        // margin-left: 130px !important;
        // padding-left: 0 !important;
        .el-button {
          font-size: 16px;
        }
      }
    }
    .job-msg {
      text-align: start;
      text-align: initial;
      line-height: 25px;
      color: #333;
      margin: 50px auto;
      padding: 20px 0;
      border: 1px solid #cccccc;
      width: 65%;
      p {
        padding-left: 30px !important;
        font-family: 'Microsoft YaHei', '微软雅黑' !important;
      }
      span {
        font-family: 'Microsoft YaHei', '微软雅黑' !important;
      }
    }
  }
  .el-dialog {
    .el-dialog__header {
      text-align: start;
      text-align: initial;
      border-bottom: solid 1px #e1e1e1;
      padding: 20px 20px 20px;
      .el-dialog__title {
        font-size: 18px;
        font-weight: 500;
        color: #202020;
      }
    }
    .el-dialog__footer {
      padding-top: 20px;
      border-top: solid 1px #e1e1e1;
    }
    .emailMsg {
      .el-form-item__content {
        text-align: center;
        font-size: 18px;
        color: #0d7ef8;
        font-weight: 500;
      }
    }
  }
}
</style>
